import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** A short status word. Never a sentence — the tone has to read at a glance. */
export function Badge({ children, tone = 'neutral', dot = true }) {
    return (_jsxs("span", { className: `lh-badge lh-badge--${tone}`, children: [dot && _jsx("span", { className: "lh-badge__dot", "aria-hidden": "true" }), children] }));
}
//# sourceMappingURL=Badge.js.map